export const OPERATOR_LIST_COLUMNS = [
  { field: 'radio', headerName: '', align: 'left' },
  { field: 'nomeUnidade', headerName: 'Unidade', align: 'left', sort: 'asc' },
  { field: 'nome', headerName: 'Colaborador', align: 'left', sort: 'asc' },
  { field: 'cpf', headerName: 'CPF', align: 'left', sort: 'asc' },
  {
    field: 'numeroNaOperadora',
    headerName: 'No.ped.Op',
    align: 'center',
    sort: 'asc'
  },
  {
    field: 'numeroCartao',
    headerName: 'N° Cartão',
    align: 'center',
    sort: 'asc'
  },
  { field: 'acoes', headerName: '', align: 'center' }
]
